var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var punycode = createCommonjsModule(function (module, exports) {
(function(root) {

	/** Detect free variables */
	var freeExports =  exports &&
		!exports.nodeType && exports;
	var freeModule =  module &&
		!module.nodeType && module;
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (freeExports && freeModule) {
		if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.punycode = punycode;
	}

}(commonjsGlobal));
});

// Copyright Joyent, Inc. and other Node contributors.

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var decode = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

// Copyright Joyent, Inc. and other Node contributors.

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

var encode = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var querystring = createCommonjsModule(function (module, exports) {

exports.decode = exports.parse = decode;
exports.encode = exports.stringify = encode;
});
var querystring_1 = querystring.decode;
var querystring_2 = querystring.parse;
var querystring_3 = querystring.encode;
var querystring_4 = querystring.stringify;

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var parse = urlParse;
var format = urlFormat;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    };

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a puny coded representation of "domain".
      // It only converts the part of the domain name that
      // has non ASCII characters. I.e. it dosent matter if
      // you call it with a domain that already is in ASCII.
      var domainArray = this.hostname.split('.');
      var newOut = [];
      for (var i = 0; i < domainArray.length; ++i) {
        var s = domainArray[i];
        newOut.push(s.match(/[^A-Za-z0-9_-]/) ?
            'xn--' + punycode.encode(s) : s);
      }
      this.hostname = newOut.join('.');
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

Url.prototype.resolveObject = function(relative) {
  if (isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  Object.keys(this).forEach(function(k) {
    result[k] = this[k];
  }, this);

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    Object.keys(relative).forEach(function(k) {
      if (k !== 'protocol')
        result[k] = relative[k];
    });

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      Object.keys(relative).forEach(function(k) {
        result[k] = relative[k];
      });
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especialy happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!isNull(result.pathname) || !isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host) && (last === '.' || last === '..') ||
      last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last == '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especialy happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!isNull(result.pathname) || !isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};

function isString(arg) {
  return typeof arg === "string";
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isNull(arg) {
  return arg === null;
}
function isNullOrUndefined(arg) {
  return  arg == null;
}

var global$1 =
  (typeof globalThis !== 'undefined' && globalThis) ||
  (typeof self !== 'undefined' && self) ||
  (typeof global$1 !== 'undefined' && global$1);

var support = {
  searchParams: 'URLSearchParams' in global$1,
  iterable: 'Symbol' in global$1 && 'iterator' in Symbol,
  blob:
    'FileReader' in global$1 &&
    'Blob' in global$1 &&
    (function() {
      try {
        new Blob();
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in global$1,
  arrayBuffer: 'ArrayBuffer' in global$1
};

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ];

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    };
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name);
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
    throw new TypeError('Invalid character in header field name: "' + name + '"')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value);
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift();
      return {done: value === undefined, value: value}
    }
  };

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    };
  }

  return iterator
}

function Headers(headers) {
  this.map = {};

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value);
    }, this);
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1]);
    }, this);
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name]);
    }, this);
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name);
  value = normalizeValue(value);
  var oldValue = this.map[name];
  this.map[name] = oldValue ? oldValue + ', ' + value : value;
};

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)];
};

Headers.prototype.get = function(name) {
  name = normalizeName(name);
  return this.has(name) ? this.map[name] : null
};

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
};

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value);
};

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this);
    }
  }
};

Headers.prototype.keys = function() {
  var items = [];
  this.forEach(function(value, name) {
    items.push(name);
  });
  return iteratorFor(items)
};

Headers.prototype.values = function() {
  var items = [];
  this.forEach(function(value) {
    items.push(value);
  });
  return iteratorFor(items)
};

Headers.prototype.entries = function() {
  var items = [];
  this.forEach(function(value, name) {
    items.push([name, value]);
  });
  return iteratorFor(items)
};

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true;
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result);
    };
    reader.onerror = function() {
      reject(reader.error);
    };
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader();
  var promise = fileReaderReady(reader);
  reader.readAsArrayBuffer(blob);
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader();
  var promise = fileReaderReady(reader);
  reader.readAsText(blob);
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf);
  var chars = new Array(view.length);

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i]);
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength);
    view.set(new Uint8Array(buf));
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false;

  this._initBody = function(body) {
    /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */
    this.bodyUsed = this.bodyUsed;
    this._bodyInit = body;
    if (!body) {
      this._bodyText = '';
    } else if (typeof body === 'string') {
      this._bodyText = body;
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body;
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body;
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString();
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer);
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer]);
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body);
    } else {
      this._bodyText = body = Object.prototype.toString.call(body);
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8');
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type);
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
      }
    }
  };

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    };

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        var isConsumed = consumed(this);
        if (isConsumed) {
          return isConsumed
        }
        if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
          return Promise.resolve(
            this._bodyArrayBuffer.buffer.slice(
              this._bodyArrayBuffer.byteOffset,
              this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
            )
          )
        } else {
          return Promise.resolve(this._bodyArrayBuffer)
        }
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    };
  }

  this.text = function() {
    var rejected = consumed(this);
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  };

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode$1)
    };
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  };

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

function normalizeMethod(method) {
  var upcased = method.toUpperCase();
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  if (!(this instanceof Request)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }

  options = options || {};
  var body = options.body;

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url;
    this.credentials = input.credentials;
    if (!options.headers) {
      this.headers = new Headers(input.headers);
    }
    this.method = input.method;
    this.mode = input.mode;
    this.signal = input.signal;
    if (!body && input._bodyInit != null) {
      body = input._bodyInit;
      input.bodyUsed = true;
    }
  } else {
    this.url = String(input);
  }

  this.credentials = options.credentials || this.credentials || 'same-origin';
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers);
  }
  this.method = normalizeMethod(options.method || this.method || 'GET');
  this.mode = options.mode || this.mode || null;
  this.signal = options.signal || this.signal;
  this.referrer = null;

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body);

  if (this.method === 'GET' || this.method === 'HEAD') {
    if (options.cache === 'no-store' || options.cache === 'no-cache') {
      // Search for a '_' parameter in the query string
      var reParamSearch = /([?&])_=[^&]*/;
      if (reParamSearch.test(this.url)) {
        // If it already exists then set the value with the current time
        this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
      } else {
        // Otherwise add a new '_' parameter to the end with the current time
        var reQueryString = /\?/;
        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
      }
    }
  }
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
};

function decode$1(body) {
  var form = new FormData();
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=');
        var name = split.shift().replace(/\+/g, ' ');
        var value = split.join('=').replace(/\+/g, ' ');
        form.append(decodeURIComponent(name), decodeURIComponent(value));
      }
    });
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers();
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
  // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
  // https://github.com/github/fetch/issues/748
  // https://github.com/zloirock/core-js/issues/751
  preProcessedHeaders
    .split('\r')
    .map(function(header) {
      return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
    })
    .forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
  return headers
}

Body.call(Request.prototype);

function Response(bodyInit, options) {
  if (!(this instanceof Response)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }
  if (!options) {
    options = {};
  }

  this.type = 'default';
  this.status = options.status === undefined ? 200 : options.status;
  this.ok = this.status >= 200 && this.status < 300;
  this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
  this.headers = new Headers(options.headers);
  this.url = options.url || '';
  this._initBody(bodyInit);
}

Body.call(Response.prototype);

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
};

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''});
  response.type = 'error';
  return response
};

var redirectStatuses = [301, 302, 303, 307, 308];

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
};

var DOMException = global$1.DOMException;
try {
  new DOMException();
} catch (err) {
  DOMException = function(message, name) {
    this.message = message;
    this.name = name;
    var error = Error(message);
    this.stack = error.stack;
  };
  DOMException.prototype = Object.create(Error.prototype);
  DOMException.prototype.constructor = DOMException;
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init);

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest();

    function abortXhr() {
      xhr.abort();
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      };
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
      var body = 'response' in xhr ? xhr.response : xhr.responseText;
      setTimeout(function() {
        resolve(new Response(body, options));
      }, 0);
    };

    xhr.onerror = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'));
      }, 0);
    };

    xhr.ontimeout = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'));
      }, 0);
    };

    xhr.onabort = function() {
      setTimeout(function() {
        reject(new DOMException('Aborted', 'AbortError'));
      }, 0);
    };

    function fixUrl(url) {
      try {
        return url === '' && global$1.location.href ? global$1.location.href : url
      } catch (e) {
        return url
      }
    }

    xhr.open(request.method, fixUrl(request.url), true);

    if (request.credentials === 'include') {
      xhr.withCredentials = true;
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false;
    }

    if ('responseType' in xhr) {
      if (support.blob) {
        xhr.responseType = 'blob';
      } else if (
        support.arrayBuffer &&
        request.headers.get('Content-Type') &&
        request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
      ) {
        xhr.responseType = 'arraybuffer';
      }
    }

    if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
      Object.getOwnPropertyNames(init.headers).forEach(function(name) {
        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
      });
    } else {
      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });
    }

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr);

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr);
        }
      };
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
  })
}

fetch.polyfill = true;

if (!global$1.fetch) {
  global$1.fetch = fetch;
  global$1.Headers = Headers;
  global$1.Request = Request;
  global$1.Response = Response;
}

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.

var fetchNpmBrowserify = self.fetch.bind(self);

/// <reference path="./custom.d.ts" />
const BASE_PATH = "/".replace(/\/+$/, "");
/**
 *
 * @export
 */
const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
class BaseAPI {
    constructor(configuration, basePath = BASE_PATH, fetch = fetchNpmBrowserify) {
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        this.field = field;
    }
}
/**
 *
 * @export
 * @enum {string}
 */
var FreeplayLeague;
(function (FreeplayLeague) {
    FreeplayLeague[FreeplayLeague["Nhl"] = 'nhl'] = "Nhl";
    FreeplayLeague[FreeplayLeague["Nba"] = 'nba'] = "Nba";
    FreeplayLeague[FreeplayLeague["Mlb"] = 'mlb'] = "Mlb";
    FreeplayLeague[FreeplayLeague["Nfl"] = 'nfl'] = "Nfl";
    FreeplayLeague[FreeplayLeague["HorseRacing"] = 'horseRacing'] = "HorseRacing";
    FreeplayLeague[FreeplayLeague["Other"] = 'other'] = "Other";
})(FreeplayLeague || (FreeplayLeague = {}));
/**
 * AnalyticsApi - fetch parameter creator
 * @export
 */
const AnalyticsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerV1GetAnalyticsJSON(options = {}) {
            const localVarPath = `/api/v1/analytics`;
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AnalyticsApi - functional programming interface
 * @export
 */
const AnalyticsApiFp = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerV1GetAnalyticsJSON(options) {
            const localVarFetchArgs = AnalyticsApiFetchParamCreator().analyticsControllerV1GetAnalyticsJSON(options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * AnalyticsApi - factory interface
 * @export
 */
const AnalyticsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerV1GetAnalyticsJSON(options) {
            return AnalyticsApiFp().analyticsControllerV1GetAnalyticsJSON(options)(fetch, basePath);
        },
    };
};
/**
 * AnalyticsApi - object-oriented interface
 * @export
 * @class AnalyticsApi
 * @extends {BaseAPI}
 */
class AnalyticsApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    analyticsControllerV1GetAnalyticsJSON(options) {
        return AnalyticsApiFp(this.configuration).analyticsControllerV1GetAnalyticsJSON(options)(this.fetch, this.basePath);
    }
}
/**
 * AuthApi - fetch parameter creator
 * @export
 */
const AuthApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Log a user in with a jwt, to a given tenant
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogin(tenantSlug, options = {}) {
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling authControllerLogin.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/auth/login`
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AuthApi - functional programming interface
 * @export
 */
const AuthApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Log a user in with a jwt, to a given tenant
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogin(tenantSlug, options) {
            const localVarFetchArgs = AuthApiFetchParamCreator().authControllerLogin(tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * AuthApi - factory interface
 * @export
 */
const AuthApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Log a user in with a jwt, to a given tenant
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogin(tenantSlug, options) {
            return AuthApiFp().authControllerLogin(tenantSlug, options)(fetch, basePath);
        },
    };
};
/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
class AuthApi extends BaseAPI {
    /**
     *
     * @summary Log a user in with a jwt, to a given tenant
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    authControllerLogin(tenantSlug, options) {
        return AuthApiFp(this.configuration).authControllerLogin(tenantSlug, options)(this.fetch, this.basePath);
    }
}
/**
 * EventsApi - fetch parameter creator
 * @export
 */
const EventsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Submit picks. Will know if it's user or ambassador and set things up
         * @param {PlayerCreateBetDTO} body
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1AddPicks(body, eventId, tenantSlug, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling eventsControllerV1AddPicks.');
            }
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId', 'Required parameter eventId was null or undefined when calling eventsControllerV1AddPicks.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1AddPicks.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events/{eventId}/bet`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body =  JSON.stringify(body || {}) ;
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {AddPropToEventDTO} body
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1AddPropToEvent(body, eventId, tenantSlug, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling eventsControllerV1AddPropToEvent.');
            }
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId', 'Required parameter eventId was null or undefined when calling eventsControllerV1AddPropToEvent.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1AddPropToEvent.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events/{eventId}/add-prop`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body =  JSON.stringify(body || {}) ;
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Add props to event with horseRaces
         * @param {AddPropToEventWithHorseRacesDTO} body
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1AddPropToEventWithHorseRaces(body, eventId, tenantSlug, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling eventsControllerV1AddPropToEventWithHorseRaces.');
            }
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId', 'Required parameter eventId was null or undefined when calling eventsControllerV1AddPropToEventWithHorseRaces.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1AddPropToEventWithHorseRaces.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events/{eventId}/add-horse-race-prop`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body =  JSON.stringify(body || {}) ;
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create custom event (admin)
         * @param {CreateEventDTO} body
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1CreateCustomEvent(body, tenantSlug, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling eventsControllerV1CreateCustomEvent.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1CreateCustomEvent.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events/create-custom-event`
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body =  JSON.stringify(body || {}) ;
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create event (Admin)
         * @param {CreateEventDTO} body
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1CreateEvent(body, tenantSlug, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling eventsControllerV1CreateEvent.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1CreateEvent.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events`
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body =  JSON.stringify(body || {}) ;
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete an event and all it's associated event entries (DANGER) (Admin)
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1DeleteEvent(eventId, tenantSlug, options = {}) {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId', 'Required parameter eventId was null or undefined when calling eventsControllerV1DeleteEvent.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1DeleteEvent.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List available events (public)
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetAllActiveEvents(tenantSlug, options = {}) {
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1GetAllActiveEvents.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events`
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  Gets all available platform events for a league
         * @param {string} league
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetAllPlatformEventsForLeague(league, tenantSlug, options = {}) {
            // verify required parameter 'league' is not null or undefined
            if (league === null || league === undefined) {
                throw new RequiredError('league', 'Required parameter league was null or undefined when calling eventsControllerV1GetAllPlatformEventsForLeague.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1GetAllPlatformEventsForLeague.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events/get-all-platform-events/{league}`
                .replace(`{${"league"}}`, encodeURIComponent(String(league)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get winner(s) of a resolved event.
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetEventWinner(id, tenantSlug, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling eventsControllerV1GetEventWinner.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1GetEventWinner.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events/{id}/winners`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get leaderboard for event
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetLeaderboardForEvent(id, tenantSlug, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling eventsControllerV1GetLeaderboardForEvent.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1GetLeaderboardForEvent.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events/{id}/leaderboard`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get single event
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetOneEvent(id, tenantSlug, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling eventsControllerV1GetOneEvent.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1GetOneEvent.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get betting data for player, including ambassador picks (will change prob)
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetPlayerBetView(id, tenantSlug, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling eventsControllerV1GetPlayerBetView.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1GetPlayerBetView.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events/{id}/player`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get event history for a specific player.
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetPlayerHistory(tenantSlug, options = {}) {
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1GetPlayerHistory.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events/history`
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} eventId
         * @param {number} propId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1RemovePropFromEvent(eventId, propId, tenantSlug, options = {}) {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId', 'Required parameter eventId was null or undefined when calling eventsControllerV1RemovePropFromEvent.');
            }
            // verify required parameter 'propId' is not null or undefined
            if (propId === null || propId === undefined) {
                throw new RequiredError('propId', 'Required parameter propId was null or undefined when calling eventsControllerV1RemovePropFromEvent.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1RemovePropFromEvent.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events/{eventId}/remove-prop/{propId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"propId"}}`, encodeURIComponent(String(propId)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Remove prop from horse race prompt
         * @param {number} eventId
         * @param {number} propId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1RemovePropFromHorseRacePrompt(eventId, propId, tenantSlug, options = {}) {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId', 'Required parameter eventId was null or undefined when calling eventsControllerV1RemovePropFromHorseRacePrompt.');
            }
            // verify required parameter 'propId' is not null or undefined
            if (propId === null || propId === undefined) {
                throw new RequiredError('propId', 'Required parameter propId was null or undefined when calling eventsControllerV1RemovePropFromHorseRacePrompt.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1RemovePropFromHorseRacePrompt.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events/{eventId}/horse-remove-prop/{propId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"propId"}}`, encodeURIComponent(String(propId)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SetBespokeResolutionsForEventDTO} body
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1SetBespokeResolutionsForEvent(body, eventId, tenantSlug, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling eventsControllerV1SetBespokeResolutionsForEvent.');
            }
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId', 'Required parameter eventId was null or undefined when calling eventsControllerV1SetBespokeResolutionsForEvent.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1SetBespokeResolutionsForEvent.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events/{eventId}/resolve-props`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body =  JSON.stringify(body || {}) ;
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Test platform connection
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1TestPlatformService(tenantSlug, options = {}) {
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1TestPlatformService.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events/platform`
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update event data (Admin / Ambassador)
         * @param {UpdateEventDTO} body
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1UpdateEvent(body, eventId, tenantSlug, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling eventsControllerV1UpdateEvent.');
            }
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId', 'Required parameter eventId was null or undefined when calling eventsControllerV1UpdateEvent.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling eventsControllerV1UpdateEvent.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/events/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body =  JSON.stringify(body || {}) ;
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EventsApi - functional programming interface
 * @export
 */
const EventsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Submit picks. Will know if it's user or ambassador and set things up
         * @param {PlayerCreateBetDTO} body
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1AddPicks(body, eventId, tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1AddPicks(body, eventId, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {AddPropToEventDTO} body
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1AddPropToEvent(body, eventId, tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1AddPropToEvent(body, eventId, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Add props to event with horseRaces
         * @param {AddPropToEventWithHorseRacesDTO} body
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1AddPropToEventWithHorseRaces(body, eventId, tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1AddPropToEventWithHorseRaces(body, eventId, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Create custom event (admin)
         * @param {CreateEventDTO} body
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1CreateCustomEvent(body, tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1CreateCustomEvent(body, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Create event (Admin)
         * @param {CreateEventDTO} body
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1CreateEvent(body, tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1CreateEvent(body, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Delete an event and all it's associated event entries (DANGER) (Admin)
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1DeleteEvent(eventId, tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1DeleteEvent(eventId, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary List available events (public)
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetAllActiveEvents(tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1GetAllActiveEvents(tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary  Gets all available platform events for a league
         * @param {string} league
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetAllPlatformEventsForLeague(league, tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1GetAllPlatformEventsForLeague(league, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get winner(s) of a resolved event.
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetEventWinner(id, tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1GetEventWinner(id, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get leaderboard for event
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetLeaderboardForEvent(id, tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1GetLeaderboardForEvent(id, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get single event
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetOneEvent(id, tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1GetOneEvent(id, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get betting data for player, including ambassador picks (will change prob)
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetPlayerBetView(id, tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1GetPlayerBetView(id, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get event history for a specific player.
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetPlayerHistory(tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1GetPlayerHistory(tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {number} eventId
         * @param {number} propId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1RemovePropFromEvent(eventId, propId, tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1RemovePropFromEvent(eventId, propId, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Remove prop from horse race prompt
         * @param {number} eventId
         * @param {number} propId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1RemovePropFromHorseRacePrompt(eventId, propId, tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1RemovePropFromHorseRacePrompt(eventId, propId, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {SetBespokeResolutionsForEventDTO} body
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1SetBespokeResolutionsForEvent(body, eventId, tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1SetBespokeResolutionsForEvent(body, eventId, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Test platform connection
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1TestPlatformService(tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1TestPlatformService(tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Update event data (Admin / Ambassador)
         * @param {UpdateEventDTO} body
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1UpdateEvent(body, eventId, tenantSlug, options) {
            const localVarFetchArgs = EventsApiFetchParamCreator().eventsControllerV1UpdateEvent(body, eventId, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * EventsApi - factory interface
 * @export
 */
const EventsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Submit picks. Will know if it's user or ambassador and set things up
         * @param {PlayerCreateBetDTO} body
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1AddPicks(body, eventId, tenantSlug, options) {
            return EventsApiFp().eventsControllerV1AddPicks(body, eventId, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @param {AddPropToEventDTO} body
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1AddPropToEvent(body, eventId, tenantSlug, options) {
            return EventsApiFp().eventsControllerV1AddPropToEvent(body, eventId, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary Add props to event with horseRaces
         * @param {AddPropToEventWithHorseRacesDTO} body
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1AddPropToEventWithHorseRaces(body, eventId, tenantSlug, options) {
            return EventsApiFp().eventsControllerV1AddPropToEventWithHorseRaces(body, eventId, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create custom event (admin)
         * @param {CreateEventDTO} body
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1CreateCustomEvent(body, tenantSlug, options) {
            return EventsApiFp().eventsControllerV1CreateCustomEvent(body, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create event (Admin)
         * @param {CreateEventDTO} body
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1CreateEvent(body, tenantSlug, options) {
            return EventsApiFp().eventsControllerV1CreateEvent(body, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete an event and all it's associated event entries (DANGER) (Admin)
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1DeleteEvent(eventId, tenantSlug, options) {
            return EventsApiFp().eventsControllerV1DeleteEvent(eventId, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary List available events (public)
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetAllActiveEvents(tenantSlug, options) {
            return EventsApiFp().eventsControllerV1GetAllActiveEvents(tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary  Gets all available platform events for a league
         * @param {string} league
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetAllPlatformEventsForLeague(league, tenantSlug, options) {
            return EventsApiFp().eventsControllerV1GetAllPlatformEventsForLeague(league, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get winner(s) of a resolved event.
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetEventWinner(id, tenantSlug, options) {
            return EventsApiFp().eventsControllerV1GetEventWinner(id, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get leaderboard for event
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetLeaderboardForEvent(id, tenantSlug, options) {
            return EventsApiFp().eventsControllerV1GetLeaderboardForEvent(id, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get single event
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetOneEvent(id, tenantSlug, options) {
            return EventsApiFp().eventsControllerV1GetOneEvent(id, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get betting data for player, including ambassador picks (will change prob)
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetPlayerBetView(id, tenantSlug, options) {
            return EventsApiFp().eventsControllerV1GetPlayerBetView(id, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get event history for a specific player.
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1GetPlayerHistory(tenantSlug, options) {
            return EventsApiFp().eventsControllerV1GetPlayerHistory(tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @param {number} eventId
         * @param {number} propId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1RemovePropFromEvent(eventId, propId, tenantSlug, options) {
            return EventsApiFp().eventsControllerV1RemovePropFromEvent(eventId, propId, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary Remove prop from horse race prompt
         * @param {number} eventId
         * @param {number} propId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1RemovePropFromHorseRacePrompt(eventId, propId, tenantSlug, options) {
            return EventsApiFp().eventsControllerV1RemovePropFromHorseRacePrompt(eventId, propId, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @param {SetBespokeResolutionsForEventDTO} body
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1SetBespokeResolutionsForEvent(body, eventId, tenantSlug, options) {
            return EventsApiFp().eventsControllerV1SetBespokeResolutionsForEvent(body, eventId, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary Test platform connection
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1TestPlatformService(tenantSlug, options) {
            return EventsApiFp().eventsControllerV1TestPlatformService(tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update event data (Admin / Ambassador)
         * @param {UpdateEventDTO} body
         * @param {number} eventId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerV1UpdateEvent(body, eventId, tenantSlug, options) {
            return EventsApiFp().eventsControllerV1UpdateEvent(body, eventId, tenantSlug, options)(fetch, basePath);
        },
    };
};
/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
class EventsApi extends BaseAPI {
    /**
     *
     * @summary Submit picks. Will know if it's user or ambassador and set things up
     * @param {PlayerCreateBetDTO} body
     * @param {number} eventId
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1AddPicks(body, eventId, tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1AddPicks(body, eventId, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {AddPropToEventDTO} body
     * @param {number} eventId
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1AddPropToEvent(body, eventId, tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1AddPropToEvent(body, eventId, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Add props to event with horseRaces
     * @param {AddPropToEventWithHorseRacesDTO} body
     * @param {number} eventId
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1AddPropToEventWithHorseRaces(body, eventId, tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1AddPropToEventWithHorseRaces(body, eventId, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Create custom event (admin)
     * @param {CreateEventDTO} body
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1CreateCustomEvent(body, tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1CreateCustomEvent(body, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Create event (Admin)
     * @param {CreateEventDTO} body
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1CreateEvent(body, tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1CreateEvent(body, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Delete an event and all it's associated event entries (DANGER) (Admin)
     * @param {number} eventId
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1DeleteEvent(eventId, tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1DeleteEvent(eventId, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary List available events (public)
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1GetAllActiveEvents(tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1GetAllActiveEvents(tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary  Gets all available platform events for a league
     * @param {string} league
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1GetAllPlatformEventsForLeague(league, tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1GetAllPlatformEventsForLeague(league, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get winner(s) of a resolved event.
     * @param {number} id
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1GetEventWinner(id, tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1GetEventWinner(id, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get leaderboard for event
     * @param {number} id
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1GetLeaderboardForEvent(id, tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1GetLeaderboardForEvent(id, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get single event
     * @param {number} id
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1GetOneEvent(id, tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1GetOneEvent(id, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get betting data for player, including ambassador picks (will change prob)
     * @param {number} id
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1GetPlayerBetView(id, tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1GetPlayerBetView(id, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get event history for a specific player.
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1GetPlayerHistory(tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1GetPlayerHistory(tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {number} eventId
     * @param {number} propId
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1RemovePropFromEvent(eventId, propId, tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1RemovePropFromEvent(eventId, propId, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Remove prop from horse race prompt
     * @param {number} eventId
     * @param {number} propId
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1RemovePropFromHorseRacePrompt(eventId, propId, tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1RemovePropFromHorseRacePrompt(eventId, propId, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {SetBespokeResolutionsForEventDTO} body
     * @param {number} eventId
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1SetBespokeResolutionsForEvent(body, eventId, tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1SetBespokeResolutionsForEvent(body, eventId, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Test platform connection
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1TestPlatformService(tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1TestPlatformService(tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Update event data (Admin / Ambassador)
     * @param {UpdateEventDTO} body
     * @param {number} eventId
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    eventsControllerV1UpdateEvent(body, eventId, tenantSlug, options) {
        return EventsApiFp(this.configuration).eventsControllerV1UpdateEvent(body, eventId, tenantSlug, options)(this.fetch, this.basePath);
    }
}
/**
 * GamesApi - fetch parameter creator
 * @export
 */
const GamesApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary (Tenant Admin only) Create game
         * @param {CreateGameDTO} body
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1CreateGame(body, tenantSlug, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling gamesControllerV1CreateGame.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling gamesControllerV1CreateGame.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/games`
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body =  JSON.stringify(body || {}) ;
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Admin only) Delete a game and all it's associated events and event entries (DANGER)
         * @param {number} gameId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1DeleteGame(gameId, tenantSlug, options = {}) {
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId', 'Required parameter gameId was null or undefined when calling gamesControllerV1DeleteGame.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling gamesControllerV1DeleteGame.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/games/{gameId}`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List available games
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1GetAllActiveGames(tenantSlug, options = {}) {
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling gamesControllerV1GetAllActiveGames.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/games`
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Admin only) Get creation data for event
         * @param {number} gameId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1GetEventDataForCreation(gameId, tenantSlug, options = {}) {
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId', 'Required parameter gameId was null or undefined when calling gamesControllerV1GetEventDataForCreation.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling gamesControllerV1GetEventDataForCreation.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/games/{gameId}/create-event-data`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get game wide leaderboard
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1GetLeaderboardForGame(id, tenantSlug, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling gamesControllerV1GetLeaderboardForGame.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling gamesControllerV1GetLeaderboardForGame.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/games/{id}/leaderboard`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get one game
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1GetOneGame(id, tenantSlug, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling gamesControllerV1GetOneGame.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling gamesControllerV1GetOneGame.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/games/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Tenant Admin only) Update game
         * @param {UpdateGameDTO} body
         * @param {number} gameId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1UpdateGame(body, gameId, tenantSlug, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling gamesControllerV1UpdateGame.');
            }
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId', 'Required parameter gameId was null or undefined when calling gamesControllerV1UpdateGame.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling gamesControllerV1UpdateGame.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/games/{gameId}`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body =  JSON.stringify(body || {}) ;
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * GamesApi - functional programming interface
 * @export
 */
const GamesApiFp = function (configuration) {
    return {
        /**
         *
         * @summary (Tenant Admin only) Create game
         * @param {CreateGameDTO} body
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1CreateGame(body, tenantSlug, options) {
            const localVarFetchArgs = GamesApiFetchParamCreator().gamesControllerV1CreateGame(body, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary  (Admin only) Delete a game and all it's associated events and event entries (DANGER)
         * @param {number} gameId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1DeleteGame(gameId, tenantSlug, options) {
            const localVarFetchArgs = GamesApiFetchParamCreator().gamesControllerV1DeleteGame(gameId, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary List available games
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1GetAllActiveGames(tenantSlug, options) {
            const localVarFetchArgs = GamesApiFetchParamCreator().gamesControllerV1GetAllActiveGames(tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary  (Admin only) Get creation data for event
         * @param {number} gameId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1GetEventDataForCreation(gameId, tenantSlug, options) {
            const localVarFetchArgs = GamesApiFetchParamCreator().gamesControllerV1GetEventDataForCreation(gameId, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get game wide leaderboard
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1GetLeaderboardForGame(id, tenantSlug, options) {
            const localVarFetchArgs = GamesApiFetchParamCreator().gamesControllerV1GetLeaderboardForGame(id, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get one game
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1GetOneGame(id, tenantSlug, options) {
            const localVarFetchArgs = GamesApiFetchParamCreator().gamesControllerV1GetOneGame(id, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary  (Tenant Admin only) Update game
         * @param {UpdateGameDTO} body
         * @param {number} gameId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1UpdateGame(body, gameId, tenantSlug, options) {
            const localVarFetchArgs = GamesApiFetchParamCreator().gamesControllerV1UpdateGame(body, gameId, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * GamesApi - factory interface
 * @export
 */
const GamesApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary (Tenant Admin only) Create game
         * @param {CreateGameDTO} body
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1CreateGame(body, tenantSlug, options) {
            return GamesApiFp().gamesControllerV1CreateGame(body, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary  (Admin only) Delete a game and all it's associated events and event entries (DANGER)
         * @param {number} gameId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1DeleteGame(gameId, tenantSlug, options) {
            return GamesApiFp().gamesControllerV1DeleteGame(gameId, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary List available games
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1GetAllActiveGames(tenantSlug, options) {
            return GamesApiFp().gamesControllerV1GetAllActiveGames(tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary  (Admin only) Get creation data for event
         * @param {number} gameId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1GetEventDataForCreation(gameId, tenantSlug, options) {
            return GamesApiFp().gamesControllerV1GetEventDataForCreation(gameId, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get game wide leaderboard
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1GetLeaderboardForGame(id, tenantSlug, options) {
            return GamesApiFp().gamesControllerV1GetLeaderboardForGame(id, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get one game
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1GetOneGame(id, tenantSlug, options) {
            return GamesApiFp().gamesControllerV1GetOneGame(id, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary  (Tenant Admin only) Update game
         * @param {UpdateGameDTO} body
         * @param {number} gameId
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesControllerV1UpdateGame(body, gameId, tenantSlug, options) {
            return GamesApiFp().gamesControllerV1UpdateGame(body, gameId, tenantSlug, options)(fetch, basePath);
        },
    };
};
/**
 * GamesApi - object-oriented interface
 * @export
 * @class GamesApi
 * @extends {BaseAPI}
 */
class GamesApi extends BaseAPI {
    /**
     *
     * @summary (Tenant Admin only) Create game
     * @param {CreateGameDTO} body
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApi
     */
    gamesControllerV1CreateGame(body, tenantSlug, options) {
        return GamesApiFp(this.configuration).gamesControllerV1CreateGame(body, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary  (Admin only) Delete a game and all it's associated events and event entries (DANGER)
     * @param {number} gameId
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApi
     */
    gamesControllerV1DeleteGame(gameId, tenantSlug, options) {
        return GamesApiFp(this.configuration).gamesControllerV1DeleteGame(gameId, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary List available games
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApi
     */
    gamesControllerV1GetAllActiveGames(tenantSlug, options) {
        return GamesApiFp(this.configuration).gamesControllerV1GetAllActiveGames(tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary  (Admin only) Get creation data for event
     * @param {number} gameId
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApi
     */
    gamesControllerV1GetEventDataForCreation(gameId, tenantSlug, options) {
        return GamesApiFp(this.configuration).gamesControllerV1GetEventDataForCreation(gameId, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get game wide leaderboard
     * @param {number} id
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApi
     */
    gamesControllerV1GetLeaderboardForGame(id, tenantSlug, options) {
        return GamesApiFp(this.configuration).gamesControllerV1GetLeaderboardForGame(id, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get one game
     * @param {number} id
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApi
     */
    gamesControllerV1GetOneGame(id, tenantSlug, options) {
        return GamesApiFp(this.configuration).gamesControllerV1GetOneGame(id, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary  (Tenant Admin only) Update game
     * @param {UpdateGameDTO} body
     * @param {number} gameId
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApi
     */
    gamesControllerV1UpdateGame(body, gameId, tenantSlug, options) {
        return GamesApiFp(this.configuration).gamesControllerV1UpdateGame(body, gameId, tenantSlug, options)(this.fetch, this.basePath);
    }
}
/**
 * RacingApi - fetch parameter creator
 * @export
 */
const RacingApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Default racing route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        racingPlatformControllerV1DefaultRouteHandler(options = {}) {
            const localVarPath = `/api/v1/racing`;
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a list of the days races for a given track ID.
         * @param {string} trackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        racingPlatformControllerV1GetProgramTrack(trackId, options = {}) {
            // verify required parameter 'trackId' is not null or undefined
            if (trackId === null || trackId === undefined) {
                throw new RequiredError('trackId', 'Required parameter trackId was null or undefined when calling racingPlatformControllerV1GetProgramTrack.');
            }
            const localVarPath = `/api/v1/racing/get-program-track/{trackId}`
                .replace(`{${"trackId"}}`, encodeURIComponent(String(trackId)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the race entry for a give trackId and raceId
         * @param {string} trackId
         * @param {string} raceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        racingPlatformControllerV1GetRaceEntry(trackId, raceId, options = {}) {
            // verify required parameter 'trackId' is not null or undefined
            if (trackId === null || trackId === undefined) {
                throw new RequiredError('trackId', 'Required parameter trackId was null or undefined when calling racingPlatformControllerV1GetRaceEntry.');
            }
            // verify required parameter 'raceId' is not null or undefined
            if (raceId === null || raceId === undefined) {
                throw new RequiredError('raceId', 'Required parameter raceId was null or undefined when calling racingPlatformControllerV1GetRaceEntry.');
            }
            const localVarPath = `/api/v1/racing/get-race-entry/{trackId}/{raceId}`
                .replace(`{${"trackId"}}`, encodeURIComponent(String(trackId)))
                .replace(`{${"raceId"}}`, encodeURIComponent(String(raceId)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a list of tracks with races available today.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        racingPlatformControllerV1GetTodaysTracks(options = {}) {
            const localVarPath = `/api/v1/racing/todays-tracks`;
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RacingApi - functional programming interface
 * @export
 */
const RacingApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Default racing route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        racingPlatformControllerV1DefaultRouteHandler(options) {
            const localVarFetchArgs = RacingApiFetchParamCreator().racingPlatformControllerV1DefaultRouteHandler(options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get a list of the days races for a given track ID.
         * @param {string} trackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        racingPlatformControllerV1GetProgramTrack(trackId, options) {
            const localVarFetchArgs = RacingApiFetchParamCreator().racingPlatformControllerV1GetProgramTrack(trackId, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get the race entry for a give trackId and raceId
         * @param {string} trackId
         * @param {string} raceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        racingPlatformControllerV1GetRaceEntry(trackId, raceId, options) {
            const localVarFetchArgs = RacingApiFetchParamCreator().racingPlatformControllerV1GetRaceEntry(trackId, raceId, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get a list of tracks with races available today.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        racingPlatformControllerV1GetTodaysTracks(options) {
            const localVarFetchArgs = RacingApiFetchParamCreator().racingPlatformControllerV1GetTodaysTracks(options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * RacingApi - factory interface
 * @export
 */
const RacingApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Default racing route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        racingPlatformControllerV1DefaultRouteHandler(options) {
            return RacingApiFp().racingPlatformControllerV1DefaultRouteHandler(options)(fetch, basePath);
        },
        /**
         *
         * @summary Get a list of the days races for a given track ID.
         * @param {string} trackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        racingPlatformControllerV1GetProgramTrack(trackId, options) {
            return RacingApiFp().racingPlatformControllerV1GetProgramTrack(trackId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get the race entry for a give trackId and raceId
         * @param {string} trackId
         * @param {string} raceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        racingPlatformControllerV1GetRaceEntry(trackId, raceId, options) {
            return RacingApiFp().racingPlatformControllerV1GetRaceEntry(trackId, raceId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get a list of tracks with races available today.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        racingPlatformControllerV1GetTodaysTracks(options) {
            return RacingApiFp().racingPlatformControllerV1GetTodaysTracks(options)(fetch, basePath);
        },
    };
};
/**
 * RacingApi - object-oriented interface
 * @export
 * @class RacingApi
 * @extends {BaseAPI}
 */
class RacingApi extends BaseAPI {
    /**
     *
     * @summary Default racing route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RacingApi
     */
    racingPlatformControllerV1DefaultRouteHandler(options) {
        return RacingApiFp(this.configuration).racingPlatformControllerV1DefaultRouteHandler(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get a list of the days races for a given track ID.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RacingApi
     */
    racingPlatformControllerV1GetProgramTrack(trackId, options) {
        return RacingApiFp(this.configuration).racingPlatformControllerV1GetProgramTrack(trackId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get the race entry for a give trackId and raceId
     * @param {string} trackId
     * @param {string} raceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RacingApi
     */
    racingPlatformControllerV1GetRaceEntry(trackId, raceId, options) {
        return RacingApiFp(this.configuration).racingPlatformControllerV1GetRaceEntry(trackId, raceId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get a list of tracks with races available today.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RacingApi
     */
    racingPlatformControllerV1GetTodaysTracks(options) {
        return RacingApiFp(this.configuration).racingPlatformControllerV1GetTodaysTracks(options)(this.fetch, this.basePath);
    }
}
/**
 * TenantsApi - fetch parameter creator
 * @export
 */
const TenantsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary (Admin Only) Testing only, will be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1Adminonly(options = {}) {
            const localVarPath = `/api/v1/tenants/adminonly`;
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary (Admin only) Create tenant
         * @param {CreateTenantDTO} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1CreateTenant(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling tenantControllerV1CreateTenant.');
            }
            const localVarPath = `/api/v1/tenants`;
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body =  JSON.stringify(body || {}) ;
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary (Admin only) Delete a tenant and all things. CAREFUL
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1DeleteTenant(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling tenantControllerV1DeleteTenant.');
            }
            const localVarPath = `/api/v1/tenants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary (Admin Only) List available tenants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1GetAllActiveTenants(options = {}) {
            const localVarPath = `/api/v1/tenants`;
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all tenants which the current user has the admin role.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1GetMyTenants(options = {}) {
            const localVarPath = `/api/v1/tenants/mytenants`;
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary (Public) Get one tenant
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1GetOneTenant(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling tenantControllerV1GetOneTenant.');
            }
            const localVarPath = `/api/v1/tenants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Admin only) Update tenant
         * @param {UpdateTenantDTO} body
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1UpdateTenant(body, id, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling tenantControllerV1UpdateTenant.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling tenantControllerV1UpdateTenant.');
            }
            const localVarPath = `/api/v1/tenants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body =  JSON.stringify(body || {}) ;
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TenantsApi - functional programming interface
 * @export
 */
const TenantsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary (Admin Only) Testing only, will be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1Adminonly(options) {
            const localVarFetchArgs = TenantsApiFetchParamCreator().tenantControllerV1Adminonly(options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary (Admin only) Create tenant
         * @param {CreateTenantDTO} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1CreateTenant(body, options) {
            const localVarFetchArgs = TenantsApiFetchParamCreator().tenantControllerV1CreateTenant(body, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary (Admin only) Delete a tenant and all things. CAREFUL
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1DeleteTenant(id, options) {
            const localVarFetchArgs = TenantsApiFetchParamCreator().tenantControllerV1DeleteTenant(id, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary (Admin Only) List available tenants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1GetAllActiveTenants(options) {
            const localVarFetchArgs = TenantsApiFetchParamCreator().tenantControllerV1GetAllActiveTenants(options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get all tenants which the current user has the admin role.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1GetMyTenants(options) {
            const localVarFetchArgs = TenantsApiFetchParamCreator().tenantControllerV1GetMyTenants(options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary (Public) Get one tenant
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1GetOneTenant(id, options) {
            const localVarFetchArgs = TenantsApiFetchParamCreator().tenantControllerV1GetOneTenant(id, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary  (Admin only) Update tenant
         * @param {UpdateTenantDTO} body
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1UpdateTenant(body, id, options) {
            const localVarFetchArgs = TenantsApiFetchParamCreator().tenantControllerV1UpdateTenant(body, id, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * TenantsApi - factory interface
 * @export
 */
const TenantsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary (Admin Only) Testing only, will be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1Adminonly(options) {
            return TenantsApiFp().tenantControllerV1Adminonly(options)(fetch, basePath);
        },
        /**
         *
         * @summary (Admin only) Create tenant
         * @param {CreateTenantDTO} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1CreateTenant(body, options) {
            return TenantsApiFp().tenantControllerV1CreateTenant(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary (Admin only) Delete a tenant and all things. CAREFUL
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1DeleteTenant(id, options) {
            return TenantsApiFp().tenantControllerV1DeleteTenant(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary (Admin Only) List available tenants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1GetAllActiveTenants(options) {
            return TenantsApiFp().tenantControllerV1GetAllActiveTenants(options)(fetch, basePath);
        },
        /**
         *
         * @summary Get all tenants which the current user has the admin role.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1GetMyTenants(options) {
            return TenantsApiFp().tenantControllerV1GetMyTenants(options)(fetch, basePath);
        },
        /**
         *
         * @summary (Public) Get one tenant
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1GetOneTenant(id, options) {
            return TenantsApiFp().tenantControllerV1GetOneTenant(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary  (Admin only) Update tenant
         * @param {UpdateTenantDTO} body
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantControllerV1UpdateTenant(body, id, options) {
            return TenantsApiFp().tenantControllerV1UpdateTenant(body, id, options)(fetch, basePath);
        },
    };
};
/**
 * TenantsApi - object-oriented interface
 * @export
 * @class TenantsApi
 * @extends {BaseAPI}
 */
class TenantsApi extends BaseAPI {
    /**
     *
     * @summary (Admin Only) Testing only, will be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantControllerV1Adminonly(options) {
        return TenantsApiFp(this.configuration).tenantControllerV1Adminonly(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary (Admin only) Create tenant
     * @param {CreateTenantDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantControllerV1CreateTenant(body, options) {
        return TenantsApiFp(this.configuration).tenantControllerV1CreateTenant(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary (Admin only) Delete a tenant and all things. CAREFUL
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantControllerV1DeleteTenant(id, options) {
        return TenantsApiFp(this.configuration).tenantControllerV1DeleteTenant(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary (Admin Only) List available tenants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantControllerV1GetAllActiveTenants(options) {
        return TenantsApiFp(this.configuration).tenantControllerV1GetAllActiveTenants(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get all tenants which the current user has the admin role.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantControllerV1GetMyTenants(options) {
        return TenantsApiFp(this.configuration).tenantControllerV1GetMyTenants(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary (Public) Get one tenant
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantControllerV1GetOneTenant(id, options) {
        return TenantsApiFp(this.configuration).tenantControllerV1GetOneTenant(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary  (Admin only) Update tenant
     * @param {UpdateTenantDTO} body
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantControllerV1UpdateTenant(body, id, options) {
        return TenantsApiFp(this.configuration).tenantControllerV1UpdateTenant(body, id, options)(this.fetch, this.basePath);
    }
}
/**
 * UsersApi - fetch parameter creator
 * @export
 */
const UsersApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get currently logged in player
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerV1GetMe(tenantSlug, options = {}) {
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling usersControllerV1GetMe.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/users/me`
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a user
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerV1GetUser(id, tenantSlug, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling usersControllerV1GetUser.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling usersControllerV1GetUser.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a user
         * @param {UserUpdateDTO} body
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerV1UpdateUser(body, id, tenantSlug, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling usersControllerV1UpdateUser.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling usersControllerV1UpdateUser.');
            }
            // verify required parameter 'tenantSlug' is not null or undefined
            if (tenantSlug === null || tenantSlug === undefined) {
                throw new RequiredError('tenantSlug', 'Required parameter tenantSlug was null or undefined when calling usersControllerV1UpdateUser.');
            }
            const localVarPath = `/api/v1/{tenantSlug}/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantSlug"}}`, encodeURIComponent(String(tenantSlug)));
            const localVarUrlObj = parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body =  JSON.stringify(body || {}) ;
            return {
                url: format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
const UsersApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get currently logged in player
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerV1GetMe(tenantSlug, options) {
            const localVarFetchArgs = UsersApiFetchParamCreator().usersControllerV1GetMe(tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get a user
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerV1GetUser(id, tenantSlug, options) {
            const localVarFetchArgs = UsersApiFetchParamCreator().usersControllerV1GetUser(id, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Update a user
         * @param {UserUpdateDTO} body
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerV1UpdateUser(body, id, tenantSlug, options) {
            const localVarFetchArgs = UsersApiFetchParamCreator().usersControllerV1UpdateUser(body, id, tenantSlug, options);
            return (fetch = fetchNpmBrowserify, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
const UsersApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Get currently logged in player
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerV1GetMe(tenantSlug, options) {
            return UsersApiFp().usersControllerV1GetMe(tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get a user
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerV1GetUser(id, tenantSlug, options) {
            return UsersApiFp().usersControllerV1GetUser(id, tenantSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a user
         * @param {UserUpdateDTO} body
         * @param {number} id
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerV1UpdateUser(body, id, tenantSlug, options) {
            return UsersApiFp().usersControllerV1UpdateUser(body, id, tenantSlug, options)(fetch, basePath);
        },
    };
};
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
class UsersApi extends BaseAPI {
    /**
     *
     * @summary Get currently logged in player
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerV1GetMe(tenantSlug, options) {
        return UsersApiFp(this.configuration).usersControllerV1GetMe(tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get a user
     * @param {number} id
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerV1GetUser(id, tenantSlug, options) {
        return UsersApiFp(this.configuration).usersControllerV1GetUser(id, tenantSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Update a user
     * @param {UserUpdateDTO} body
     * @param {number} id
     * @param {string} tenantSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerV1UpdateUser(body, id, tenantSlug, options) {
        return UsersApiFp(this.configuration).usersControllerV1UpdateUser(body, id, tenantSlug, options)(this.fetch, this.basePath);
    }
}

// tslint:disable
/**
 * Freeplay User API
 * Freeplay API. Some of the end points functionality will return different data depending on your role
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */
class Configuration {
    constructor(param = {}) {
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
    }
}

const shortLookup = {
    '182692': 'CHI',
    '182683': 'ARZ',
    '182678': 'WSH',
    '182687': 'MIN',
    '182709': 'SEA',
    '182696': 'CIN',
    '182694': 'NO',
    '182708': 'ATL',
    '182681': 'DET',
    '182697': 'HOU',
    '182706': 'DAL',
    '182700': 'PIT',
    '182698': 'BAL',
    '182693': 'LV',
};
const getNFLTeamShortForm = (teamId) => {
    return shortLookup[teamId];
};

var PlatformBetOfferType;
(function (PlatformBetOfferType) {
    PlatformBetOfferType[PlatformBetOfferType["HANDICAP"] = 1] = "HANDICAP";
    PlatformBetOfferType[PlatformBetOfferType["MATCH"] = 2] = "MATCH";
    PlatformBetOfferType[PlatformBetOfferType["OVERUNDER"] = 6] = "OVERUNDER";
})(PlatformBetOfferType || (PlatformBetOfferType = {}));
var HorseRaceWagerType;
(function (HorseRaceWagerType) {
    HorseRaceWagerType["PICKEM"] = "pickEm";
    HorseRaceWagerType["HORSETOWIN"] = "horseToWin";
    HorseRaceWagerType["TOP4"] = "top4";
    HorseRaceWagerType["WINNINGTIME"] = "winningTime";
    HorseRaceWagerType["WINNINGDISTANCE"] = "winningDistance";
})(HorseRaceWagerType || (HorseRaceWagerType = {}));
var BettingEventStatus;
(function (BettingEventStatus) {
    BettingEventStatus[BettingEventStatus["DRAFT"] = 0] = "DRAFT";
    BettingEventStatus[BettingEventStatus["PENDING_PICKS"] = 1] = "PENDING_PICKS";
    BettingEventStatus[BettingEventStatus["PUBLISHED"] = 2] = "PUBLISHED";
    BettingEventStatus[BettingEventStatus["BETTING_CLOSED"] = 3] = "BETTING_CLOSED";
    BettingEventStatus[BettingEventStatus["PENDING_SCORING"] = 4] = "PENDING_SCORING";
    BettingEventStatus[BettingEventStatus["RESULTED"] = 5] = "RESULTED";
})(BettingEventStatus || (BettingEventStatus = {}));
var WinningTimeUnits;
(function (WinningTimeUnits) {
    WinningTimeUnits[WinningTimeUnits["SECONDS"] = 0] = "SECONDS";
    WinningTimeUnits[WinningTimeUnits["MINUTES"] = 1] = "MINUTES";
})(WinningTimeUnits || (WinningTimeUnits = {}));
var WinningDistanceUnits;
(function (WinningDistanceUnits) {
    WinningDistanceUnits[WinningDistanceUnits["LENGTHS"] = 0] = "LENGTHS";
    WinningDistanceUnits[WinningDistanceUnits["NOSES"] = 1] = "NOSES";
})(WinningDistanceUnits || (WinningDistanceUnits = {}));

export { AnalyticsApi, AnalyticsApiFactory, AnalyticsApiFetchParamCreator, AnalyticsApiFp, AuthApi, AuthApiFactory, AuthApiFetchParamCreator, AuthApiFp, BaseAPI, BettingEventStatus, COLLECTION_FORMATS, Configuration, EventsApi, EventsApiFactory, EventsApiFetchParamCreator, EventsApiFp, FreeplayLeague, GamesApi, GamesApiFactory, GamesApiFetchParamCreator, GamesApiFp, HorseRaceWagerType, PlatformBetOfferType, RacingApi, RacingApiFactory, RacingApiFetchParamCreator, RacingApiFp, RequiredError, TenantsApi, TenantsApiFactory, TenantsApiFetchParamCreator, TenantsApiFp, UsersApi, UsersApiFactory, UsersApiFetchParamCreator, UsersApiFp, WinningDistanceUnits, WinningTimeUnits, getNFLTeamShortForm };
